import assessments from './models/AssessmentsHelper';
import availabilities from './models/AvailabilitiesHelper';
import coursePreregistrations from './models/CoursePreregistrationsHelper';
import courses from './models/CoursesHelper';
import codevolve from './models/CodevolveHelper';
import followedCourses from './models/FollowedCoursesHelper';
import followedPath from './models/FollowedPathHelper';
import paths from './models/PathsHelper';
import projectSessions from './models/ProjectSessionsHelper';
import jurySessions from './models/JurySessionsHelper';
import signatories from './models/SignatoriesHelper';
import studentCredentials from './models/StudentCredentialsHelper';
import studentCredentialParchmentInformations from './models/StudentCredentialParchmentInformationsHelper';
import supportExpertAssigment from './models/SupportExpertAssigmentHelper';
import videoConferences from './models/VideoConferencesHelper';
import videoConferenceConnectionCheck from './models/VideoConferenceConnectionHelperCheck';
import supports from './models/SupportsHelper';
import sessions from './models/SessionsHelper';
import studentCredentialPermissions from './models/StudentCredentialPermissionsHelper';
import sessionTermsPermissions from './models/SessionTermsPermissionsHelper';
import certifications from './models/CertificationsHelper';

export default {
  assessments,
  availabilities,
  certifications,
  codevolve,
  coursePreregistrations,
  courses,
  followedCourses,
  followedPath,
  jurySessions,
  paths,
  projectSessions,
  sessions,
  signatories,
  studentCredentials,
  studentCredentialParchmentInformations,
  studentCredentialPermissions,
  sessionTermsPermissions,
  supportExpertAssigment,
  supports,
  videoConferences,
  videoConferenceConnectionCheck,
};
